import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';


export function getPreguntaRespuestaListSuccess(preguntarespuesta) {
  return {type: types.LOAD_PREGUNTARESPUESTA_LIST_SUCCESS, preguntarespuesta};
}



export function getPreguntaRespuestaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PreguntaRespuestaApi.getPreguntaRespuestaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(preguntarespuesta => {                  
                  dispatch(getPreguntaRespuestaListSuccess(preguntarespuesta));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getPreguntaRespuestaSuccess(catalogo) {
  return {type: types.LOAD_PREGUNTARESPUESTA_SUCCESS, catalogo};
}

export function getPreguntaRespuesta(token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().PreguntaRespuestaApi.getPreguntaRespuesta(token).then(preguntarespuesta => {
            dispatch(getPreguntaRespuestaSuccess(preguntarespuesta));
        return preguntarespuesta;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(preguntarespuesta) {
  return {type: types.SAVE_PREGUNTARESPUESTA_SUCCESS, preguntarespuesta};
}


export function save(preguntarespuesta, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().PreguntaRespuestaApi.save(preguntarespuesta, token).then(preguntarespuestaGuardado => {   
    dispatch(saveSuccess(preguntarespuestaGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getPreguntaRespuestaComboSuccess(datos) {
  return {type: types.GET_PREGUNTARESPUESTAS_COMBO_SUCCESS, datos};
}

export function getPreguntaRespuestaCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().PreguntaRespuestaApi.getPreguntaRespuestaCombo(token).then(datos => {   
        
      dispatch(getPreguntaRespuestaComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(preguntarespuesta) {
  return {type: types.BORRAR_PREGUNTARESPUESTA_SUCCESS, preguntarespuesta};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PreguntaRespuestaApi.borrar(id, token ).then(preguntarespuesta => {
               
                  dispatch(borrarSuccess(preguntarespuesta));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(preguntarespuesta) {
  return {type: types.ACTIVAR_PREGUNTARESPUESTA_SUCCESS, preguntarespuesta};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PreguntaRespuestaApi.activar(id, token).then(preguntarespuesta => {
               
                  dispatch(activarSuccess(preguntarespuesta));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_PREGUNTARESPUESTA, filtro};
}



